"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityDefinition = void 0;
var react_1 = require("react");
var entity_definition_context_1 = require("../components/context/entity-definition-context");
var use_entities_1 = require("./use-entities");
var entity_type_for_1 = require("../utils/entity-type-for");
/* Use the entity definition for the givne entity instance, or the current entity definition provided by context */
var useEntityDefinition = function (entity, favourEntity) {
  if (favourEntity === void 0) {
    favourEntity = true;
  }
  var definition = (0, react_1.useContext)(entity_definition_context_1.EntityDefinitionContext);
  var entities = (0, use_entities_1.useEntities)();
  var entityDefinitionName = entity && (0, entity_type_for_1.entityTypeFor)(entity);
  if (entityDefinitionName && entities[entityDefinitionName] && (favourEntity || !definition)) {
    return entities[entityDefinitionName];
  }
  return definition;
};
exports.useEntityDefinition = useEntityDefinition;